// sticky-header-pdp js
const stickyHeader = document.getElementById('sticky-header-pdp');
const productInfoElements = document.getElementsByClassName('product-info-pdp');
const siteHeader = document.querySelector('header');
const sectionHeader = document.querySelector('.section-header'); // Reference to the section header
const buttonElement = document.querySelector('.for-pdp .product-form__buttons .button span');

// Only proceed if sticky header exists
if (stickyHeader) {
  // Mobile: Sticky header at bottom with viewport check
  if (window.innerWidth <= 749) {
    // Function to check if an element is in the viewport
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    // Function to check visibility on scroll
    function checkVisibilityOnScroll() {
      if (buttonElement && isInViewport(buttonElement)) {
        // Hide sticky header when button is in viewport
        stickyHeader.style.opacity = '0';
        stickyHeader.style.visibility = 'hidden';
      } else {
        // Show sticky header when button is NOT in viewport
        stickyHeader.style.visibility = 'visible';
        stickyHeader.style.opacity = '1';
        stickyHeader.style.position = 'fixed';
        stickyHeader.style.bottom = '0'; // Always at bottom for mobile
        stickyHeader.style.top = 'auto';
        stickyHeader.style.width = '100%';
        stickyHeader.style.zIndex = '2';
      }
    }

    // Listen for the scroll event and trigger the check
    window.addEventListener('scroll', checkVisibilityOnScroll);

    // Don't run initial check - keep header hidden until scroll happens

    // Scroll to button function
    function scrollTobtn() {
      const element = document.querySelector('.product-form__buttons');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // Attach click event to ProductAnchorButton
    if (document.getElementById('ProductAnchorButton')) {
      document.getElementById('ProductAnchorButton').onclick = scrollTobtn;
    }
  }

  if (window.innerWidth > 749) {
    // Function to calculate dynamic top position based on header and announcement bar
    function getDynamicTopPosition() {
      let topOffset = 0;

      // Get announcement bar if exists
      const announcementBar = document.querySelector('.announcement-bar, [class*="announcement"]');
      if (announcementBar) {
        const announcementRect = announcementBar.getBoundingClientRect();
        // Only add height if announcement bar is in viewport (top >= 0)
        if (announcementRect.top >= 0 && announcementRect.top < window.innerHeight) {
          topOffset += announcementBar.offsetHeight;
        }
      }

      // Get site header if exists
      if (siteHeader) {
        const headerRect = siteHeader.getBoundingClientRect();
        // Only add height if header is in viewport (top >= 0)
        if (headerRect.top >= 0 && headerRect.top < window.innerHeight) {
          topOffset += siteHeader.offsetHeight;
        }
      }

      // Get free shipping container height from CSS variable (set by global.js)
      const freeShippingHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--free-shipping-container-height')
      ) || 0;
      topOffset += freeShippingHeight;
      
      return topOffset;
    }

    // Initialize position BEFORE adding transitions to prevent initial animation
    stickyHeader.style.position = 'fixed';
    stickyHeader.style.bottom = 'auto';
    stickyHeader.style.top = `${getDynamicTopPosition()}px`; // Set initial top position
    stickyHeader.style.width = '100%';
    stickyHeader.style.zIndex = '1';
    // Keep initial hidden state from CSS
    stickyHeader.style.visibility = 'hidden';
    stickyHeader.style.opacity = '0';

    // Function to check if an element is in the viewport for desktop
    function isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function handleScroll() {
      if (buttonElement && isInViewport(buttonElement)) {
        // Hide sticky header when button is in viewport
        stickyHeader.style.opacity = '0';
        stickyHeader.style.visibility = 'hidden';
      } else {
        // Show sticky header when button is NOT in viewport
        const dynamicTop = getDynamicTopPosition();

        stickyHeader.style.visibility = 'visible';
        stickyHeader.style.opacity = '1';
        stickyHeader.style.top = `${dynamicTop}px`;
      }
    }

    // Add smooth transition ONLY for opacity and visibility (NOT top to prevent animation)
    stickyHeader.style.transition = 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out';

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Don't run initial check - keep header hidden until scroll happens

    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    if (document.getElementById('ProductAnchorButton')) {
      document.getElementById('ProductAnchorButton').onclick = scrollToTop;
    }
  }
}
